import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchCarrierLoads, logisticsActionCreators, LogisticsActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../logisticsApi';
import { ILoadMin } from '../logisticsInterfaces';

function* fetchCarrierLoadsSaga(action: FetchCarrierLoads) {
  yield put(uiActionCreators.toggleLoading('carrierLoads'));
  const response: IApiExecuteRespone<ILoadMin[]> = yield call(api.fetchCarrierLoads, action.payload.carrierId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setMinLoads(response.value));
  }

  yield put(uiActionCreators.toggleLoading('carrierLoads'));
}

export function* watchFetchCarrierLoads() {
  yield takeEvery(LogisticsActionKeys.FETCH_CARRIER_LOADS, fetchCarrierLoadsSaga);
}
